/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     MyPlan
//   Details:    My Plan compoment
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 103839 06/04/20 JC  M01  React upgrade
// 106380 01/05/20 JC  M02  Resolve error related to M01
// 111318 23/12/20 JC  M03  componentDidMount not needed
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { planActions } from '../store/MyPlan';
import Header from '../components/Header';
import Loading from '../components/Loading';
import NoItems from '../components/NoItems';
import Plan from '../components/Plan';
import AlertPanel from '../components/AlertPanel';

class MyPlan extends Component {

    //M02 define empty state to prevent warnings from getDerivedStateFromProps
    constructor(props) {
        super(props);
        this.state = {};
    }


    //M03 removed
 //   //M01 componentWillMount
 //   componentDidMount() {
	//	// This method runs when the component is first added to the page
	//	this.props.get();
	//}

    //M01
	//componentWillReceiveProps(nextProps) {
	//	// This method runs when incoming props (e.g., route params) change
	//	this.props.get();
 //   }

    //M01
    static getDerivedStateFromProps(props, state) {
        props.get();

        // Return null to indicate no change to state.
        return null;
    }

	render() {
		const { isLoading, items, error } = this.props;

		return (
			<div>
				<Header title="My Plan" />

				<div>
					{error ? <AlertPanel type="danger" message={error} /> : []}

					{isLoading ? <Loading /> : []}
					{!isLoading && (items === undefined || items.length === 0)
						? <NoItems />
						: <div className={`page-table ${isLoading ? "list-loading" : ""}`}>
							{items.map(item =>
								<Plan key={item.id} item={item} />
							)}
						</div>
					}
				</div>
			</div>
		);
	}
}

MyPlan.propTypes = {
	items: PropTypes.arrayOf(PropTypes.any),
	error: PropTypes.string,
	isLoading: PropTypes.bool
};

export default connect(
	state => state.myPlan,
	dispatch => bindActionCreators(planActions, dispatch)
)(MyPlan);
